import Box from '@mui/material/Box';

export const ActiveDot = () => (
  <Box
    component="span"
    sx={{
      display: 'inline-block',
      width: 8,
      height: 8,
      borderRadius: '50%',
      bgcolor: 'primary.main',
      flexShrink: 0,
    }}
  />
);
